(function () {
  'use strict';

  var isReconciling = false;
  var scheduled = null;

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res.json();
    });
  }

  function findOrphanAddonKeys(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    var mainGroupIds = new Set();
    cart.items.forEach(function (item) {
      var props = item && item.properties ? item.properties : {};
      if (props && props._bundle_group_id) {
        mainGroupIds.add(String(props._bundle_group_id));
      }
    });

    var orphanKeys = [];
    cart.items.forEach(function (item) {
      var props = item && item.properties ? item.properties : {};
      var parentGroupId = props && props._bundle_parent_group_id ? String(props._bundle_parent_group_id) : '';
      if (parentGroupId && !mainGroupIds.has(parentGroupId) && item.key) {
        orphanKeys.push(item.key);
      }
    });

    return orphanKeys;
  }

  function removeLineKeys(keys) {
    if (!keys || !keys.length) return Promise.resolve(false);

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      if (!res.ok) throw new Error('cart update failed');
      return true;
    });
  }

  function refreshCartUi() {
    if (window.location.pathname === '/cart') {
      window.location.reload();
      return;
    }

    document.dispatchEvent(
      new CustomEvent('flu:cart:updated', {
        detail: {},
      })
    );
  }

  function reconcileOrphanAddons() {
    if (isReconciling) return Promise.resolve();
    isReconciling = true;

    return fetchCart()
      .then(function (cart) {
        var orphanKeys = findOrphanAddonKeys(cart);
        if (!orphanKeys.length) return false;
        return removeLineKeys(orphanKeys);
      })
      .then(function (changed) {
        if (changed) refreshCartUi();
      })
      .catch(function (error) {
        console.error('bundle add-on cleanup failed', error);
      })
      .finally(function () {
        isReconciling = false;
      });
  }

  function scheduleReconcile(delay) {
    if (scheduled) window.clearTimeout(scheduled);
    scheduled = window.setTimeout(function () {
      scheduled = null;
      reconcileOrphanAddons();
    }, delay || 150);
  }

  function interceptMainRemoveClick(event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href*="/cart/change"]') : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (!href.includes('quantity=0')) return;

    var url = new URL(href, window.location.origin);
    var lineRaw = url.searchParams.get('line');
    var line = parseInt(lineRaw || '', 10);
    if (!line || line < 1) return;

    event.preventDefault();

    fetchCart()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items[line - 1]) {
          window.location.href = href;
          return null;
        }

        var mainItem = cart.items[line - 1];
        var mainProps = (mainItem && mainItem.properties) || {};
        var groupId = mainProps && mainProps._bundle_group_id ? String(mainProps._bundle_group_id) : '';

        if (!groupId || !mainItem.key) {
          window.location.href = href;
          return null;
        }

        var keysToRemove = [mainItem.key];
        cart.items.forEach(function (item) {
          var props = item && item.properties ? item.properties : {};
          var parentGroupId = props && props._bundle_parent_group_id ? String(props._bundle_parent_group_id) : '';
          if (parentGroupId === groupId && item.key) {
            keysToRemove.push(item.key);
          }
        });

        return removeLineKeys(Array.from(new Set(keysToRemove))).then(function () {
          refreshCartUi();
        });
      })
      .catch(function () {
        window.location.href = href;
      });
  }

  document.addEventListener('click', interceptMainRemoveClick, true);
  document.addEventListener('flu:cart:updated', function () {
    scheduleReconcile(200);
  });
  window.addEventListener('pageshow', function () {
    scheduleReconcile(0);
  });
})();
